<template>
  <section class="section px-5 entity-details-header">
    <div class="container">
      <div class="columns">
        <div class="column is-5">
          <div class="table-container">
            <table class="table user-table is-fullwidth">
              <tbody>
                <tr>
                  <td class="user-info-cell">
                    <div v-if="loading" class="skeleton-circle mb-2"></div>
                    <div v-else class="user-icon mb-2">
                      <i :class="icon"></i>
                    </div>

                    <div v-if="loading" class="skeleton-text"></div>
                    <div v-else class="user-status" :class="{ 'is-active': status }">
                      <i class="fas fa-circle"></i>
                      {{ status ? statusLabels.active : statusLabels.inactive }}
                    </div>
                  </td>
                  <td class="user-details-cell">
                    <div v-if="loading" class="skeleton-text my-4"></div>
                    <template v-else>
                      <span class="title">{{ subtitle }}</span>
                      <br>
                    </template>

                    <div v-if="loading" class="skeleton-text mb-2"></div>
                    <template v-else>
                      <span class="name">{{ title }}</span>
                      <br>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="column is-7">
          <div class="table-container mb-3">
            <table class="table stats-table is-fullwidth">
              <tbody>
                <tr>
                  <td class="label-cell">Fecha de registro</td>
                  <td class="value-cell">
                    <div v-if="loading" class="skeleton-text"></div>
                    <template v-else>{{ registeredAt }}</template>
                  </td>
                </tr>
                <tr v-for="detail in details" :key="detail.label">
                  <td class="label-cell">{{ detail.label }}</td>
                  <td class="value-cell">
                    <div v-if="loading" class="skeleton-text"></div>
                    <template v-else>{{ detail.value }}</template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'EntityDetailsHeader',
  props: {
    icon: {
      type: String,
      default: 'fas fa-info'
    },
    status: {
      type: Boolean,
      default: false
    },
    statusLabels: {
      type: Object,
      default: () => ({ active: 'Activo', inactive: 'Inactivo' })
    },
    title: {
      type: String,
      default: '-'
    },
    subtitle: {
      type: String,
      default: ''
    },
    registeredAt: {
      type: String,
      default: '-'
    },
    details: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.entity-details-header {
  background-color: white;
  box-shadow: 10px 0px 13px 0px rgba(0, 0, 0, 0.04);
  z-index: 9;
  overflow-x: auto;
  min-height: fit-content;
}

.columns {
  margin-top: 0;
  margin-bottom: 0;
  align-items: center;

  .column {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .column:first-child {
    position: relative;
  }

  .column:last-child {
    padding-right: 0.75rem;
  }
}

table td {
  font-family: Poppins;
}

table.user-table {
  .user-info-cell {
    vertical-align: middle;
    text-align: center;
    width: 35%;
  }

  .user-details-cell {
    width: 65%;
  }

  .skeleton-circle {
    width: 64px;
    height: 64px;
  }

  .user-icon {
    width: 64px;
    height: 64px;
    background-color: #e3dfed;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 35px;
    margin-left: auto;
    margin-right: auto;

    i {
      color: #7964a9;
    }
  }

  .user-status {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    font-weight: 600;
    font-size: 13px;

    &:not(.is-active) {
      color:#f7d56a;
    }

    &.is-active {
      color: #5fd39c
    }

    .fa-circle {
      font-size: 9px;
    }
  }

  .title {
    font-size: 22px;
    font-weight: 600;
    color: #283056;
    line-height: 2;
    overflow-wrap: break-word
  }

  .name {
    font-size: 16px;
    font-weight: 600;
    line-height: 2;
    color: #707070;
  }
}

table.stats-table {
  tbody {
    tr {
      &:nth-child(2n-1) {
        background-color: white;
      }

      &:nth-child(2n) {
        background-color: #f8f9fa;
      }

      td {
        padding: 0.75rem 1rem;
        border: none;
        text-align: start;

        &.label-cell {
          font-size: 11px;
          font-weight: 500;
          color: #bcbcbc;
          width: 25%;
        }

        &.value-cell {
          font-size: 12px;
          font-weight: 500;
          color: #121212;
        }
      }
    }
  }
}

.skeleton-circle,
.skeleton-text {
  background: #eef2fb;
  border-radius: 4px;
}

@media (min-width: 769px) {
  .column:first-child::after {
    content: "";
    position: absolute;
    height: 80%;
    width: 1px;
    top: 10%;
    right: 0;
    background-color: #dbdbdb;
  }
}

@media (max-width: 768px) {
  .columns .column {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .column:first-child::after {
    content: "";
    position: absolute;
    height: 1px;
    width: calc(100% - 1.5rem);
    bottom: 0;
    left: 0.75rem;
    background-color: #dbdbdb;
  }
}
</style>
